import { Reporter } from 'features/dataCapture';

qtee.customDesign = window.qtee.customDesign || {};

/** Preview View */
qtee.customDesign.PreviewView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/preview',
	ui: {
		previewContinue: '.previewContinue',
		pillowWrapper: '#pillowWrapper',
		modelImage: '.previewImage',
		previewOption: '.previewOption',
		addToCart: '.addToCart',
		addToFavorites: '.addToFavorites',
		qty: '.qty',
		loader: '.loadingOverlay2'
	},
	events: {
		'click @ui.previewContinue': 'previewContinueClick',
		'click @ui.previewOption:not(.active)': 'previewOptionClick',
		'click @ui.addToCart': 'addToCartClick',
		'click @ui.addToFavorites': 'addToFavoritesClick',
		'blur @ui.qty': 'normalizeQty',
		'keypress @ui.qty': 'normalizeQtyInput'
	},
	templateHelpers() {

		const that = this;
		const sku = this.model.get('ShortSku');
		let frontImageUrl;
		let defaultPillowBack = '/images/custom-design/_snow_back.jpg';
		const price = this.prodModel.get('Price').substring(1);
		const name = this.prodModel.get('ProductName');
		const isPillow = !!this.model.isPillow();
		const trimColors = (this.previewModel.get('TrimColors') || []).map((el) => ({
			active: !!(
				qtee.customDesign.previewTrimSelection && qtee.customDesign.previewTrimSelection === el.TrimColor
			),
			trim: el.TrimColor,
			color: el.HexCode,
			image: that.model.isPillow() ? el.BackImageUrl : el.FlatImageUrl,
			flatImageUrl: el.FlatImageUrl,
			backImageUrl: el.BackImageUrl,
			className: el.TrimColor.toLowerCase() + (el.IsWhiteString ? ' whiteText' : '')
		}));

		if (!qtee.customDesign.previewTrimSelection) {

			trimColors[0].active = true;
			frontImageUrl = trimColors[0].flatImageUrl;

		} else {

			const active = $.grep(trimColors, (e) => e.active == true)[0];

			defaultPillowBack = active.backImageUrl;
			frontImageUrl = active.flatImageUrl;

		}

		return {
			sku,
			frontImageUrl,
			defaultPillowBack,
			trimColors,
			name,
			price,
			isPillow,
			showWishlist() {

				return !that.options.showCart;

			},
			showCart() {

				return that.options.showCart;

			}
		};

	},
	initialize(opts) {

		const _this = this;
		this.prodModel = opts.prodModel;
		this.previewModel = opts.previewModel;

	},
	onRender() {

		$(this.ui.qty).val(this.options.qty || '1');

	},
	onAttach() {

		this.trackSkuView();

	},
	normalizeQty() {

		if (parseInt($(this.ui.qty).val()) <= 0 || $(this.ui.qty).val().trim() == '') {

			$(this.ui.qty).val('1');

		}

	},
	normalizeQtyInput(e) {

		// allow only numbers
		if (e.which > 31 && (e.which < 48 || e.which > 57)) {

			return false;

		}

		return true;

	},
	previewContinueClick(e) {

		e.preventDefault();
		$('body').lpModalClose();

	},
	previewOptionClick(e) {

		const $eventTarget = $(e.target);
		const $target = $eventTarget.is('li') ? $eventTarget : $eventTarget.parent();
		const switchImg = $($target[0]).attr('data-trim-url');

		// change color selection ui
		$('.previewOptions li').removeClass('active');
		$target.addClass('active');

		qtee.customDesign.previewTrimSelection = $target.attr('data-trim');

		if (this.model.isPillow()) {

			$('#pillowWrapper img').attr('src', switchImg);

		} else {

			$('.previewImage img').attr('src', switchImg);

		}

		this.trackSkuView();

	},
	addToCartClick() {

		this.normalizeQty();
		$('.loadingOverlay2').removeClass('hidden');
		const _this3 = this;
		const color = $('.previewOption.active').attr('data-color');
		const qty = parseInt($(this.ui.qty).val()) || 1;
		const sku = _this3.model.get('ShortSku');

		const data = [
			{
				ShortSku: sku,
				Quantity: qty,
				Name: _this3.prodModel.get('ProductName'),
				Price: _this3.prodModel.get('Price'),
				Category: _this3.prodModel.get('Category'),
				CustomizedProductToken: _this3.model.get('Token'),
				PatternColorCombination: { Trim: color },
				SkuInputType: _this3.prodModel.get('SkuInputType')
			}
		];

		let addToCartRequest;
		let skuViewRequest;
		if (window.lp.globals.enableDataCapture) {

			// add to cart data capture event
			const customizedProductId = this.model.get('CustomizedProductId');
			const { reporter } = window.lp.dataCapture;
			addToCartRequest = reporter.trackAddToCart(
				[
					{
						ShortSku: sku,
						Quantity: qty,
						SkuInputType: _this3.prodModel.get('SkuInputType'),
						customizedProductCombination: `${customizedProductId}~${color}`
					}
				],
				this.ui.addToCart[0]
			);

			const skuViewRecord = reporter.getRecordByElement(this.ui.modelImage[0]);
			// if skuview is pending, lets use that promise
			skuViewRequest = skuViewRecord ? skuViewRecord.promise : this.trackSkuView();

		}

		qtee.customDesign.utils.addToCart(
			data,
			addToCartRequest && skuViewRequest ? [addToCartRequest, skuViewRequest] : []
		);

	},
	addToFavoritesClick() {

		this.normalizeQty();
		$('.loadingOverlay2').removeClass('hidden');
		const _this4 = this;
		const color = $('.previewOption.active').attr('data-color');
		const qty = parseInt($(this.ui.qty).val()) || 1;

		qtee.customDesign.utils.addToWishlist(this.model.get('ShortSku'), qty, this.model.get('Token'), color);

	},
	trackSkuView() {

		if (!window.lp.globals.enableDataCapture) {

			return;

		}

		const skuInputTypeValue = this.prodModel.get('SkuInputType');
		const customizedProductId = this.model.get('CustomizedProductId');
		const img = this.ui.modelImage[0];
		// Set customized product combination on img
		img.dataset.customizedProductCombination = `${customizedProductId}~${$('.previewOption.active').attr(
			'data-color'
		)}`;

		const { reporter } = window.lp.dataCapture;
		const data = Reporter.getSkuViewData(this.ui.modelImage[0]);

		// eslint-disable-next-line consistent-return
		return reporter.track({ ...data, skuInputType: skuInputTypeValue }, { immediate: true });

	}
});
